
import { 
    EDIT_ORGANIZATION,
    EDIT_ORGANIZATION_SUCCESS,
    EDIT_ORGANIZATION_FAIL, 
    EDIT_ORGANIZATION_RESET,
} from "../actions/editOrganizationAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const editOrganizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ORGANIZATION:
            return {
                ...state,
                apiState: "loading",
            };
        case EDIT_ORGANIZATION_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case EDIT_ORGANIZATION_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case EDIT_ORGANIZATION_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default editOrganizationReducer;
